(function () {
    'use strict';

    angular.module("imApp").factory("settingsService", ['$q', '$ihttp', 'dataTask0To99Service', function($q, $ihttp, dataTask0To99Service) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1020,
                    parameters: parms || {}
                });
            },
            listSettings: function (parms) {
                // BJS 20260310 - Modified to call downgraded angular service
                return $q.when(dataTask0To99Service.dt53(parms || {}));
            }
        };

        return service;
    }]);
})();
